import type { BasicSelectProps } from './types';
import type { SharedSelection } from '@/components/ui';
import { Input, Select, SelectItem } from '@/components/ui';
import { useMemberStatus } from '@/store/people/hooks';

export type Props = {
  selected?: string | string[];
  isReadOnly?: boolean;
} & BasicSelectProps;

export function MemberStatusSelect({
  label,
  placeholder,
  multiple,
  onChange,
  startContent,
  className,
  selected,
  isReadOnly,
}: Props) {
  const { list } = useMemberStatus();
  // const onChangeHandler = makeOnChangeHandler({
  //   anyTarget: onChange,
  //   multiple,
  // });
  const selectionHandler = (keys: SharedSelection) => {
    debugger;
    if (!onChange) {
      return;
    }

    if (multiple) {
      onChange(Array.isArray(keys) ? keys : [keys as string]);
    } else if (keys instanceof Set && !keys.size) {
      onChange(undefined);
    } else {
      onChange(keys.currentKey);
    }
  };

  const selectedKeys =
    (Array.isArray(selected) ? selected : [selected]).filter(
      (s) => s !== undefined,
    ) || [];

  if (isReadOnly) {
    const display = selectedKeys
      .map((key) => list.find((item) => item.key === key))
      .map((item) => item?.label)
      .filter((label) => label?.length)
      .join(', ');

    return (
      <Input isReadOnly value={display} className={className} label={label} />
    );
  }

  return (
    <Select
      label={label}
      aria-label='Member Status'
      placeholder={placeholder}
      startContent={startContent}
      className={className}
      selectedKeys={selectedKeys}
      onSelectionChange={selectionHandler}
      // onChange={onChangeHandler}
      selectionMode={multiple ? 'multiple' : 'single'}
    >
      {list.map((item) => (
        <SelectItem key={item.key}>{item.label}</SelectItem>
      ))}
    </Select>
  );
}
